export default __webpack_public_path__ + "static/media/background-2.4c074b06.gif";